
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const kaid: Operator = {
	id: 'kaid',
	name: 'Kaid',
	role: 'Defender',
	org: 'GIGR',
	squad: 'REDHAMMER',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 2
	},
	meta: {
		gender: 'm',
		country: 'ma',
		season: 'Y3S4',
		height: 195,
		weight: 98,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Jalal El Fassi',
		birthplace: 'Aroumd, Morocco'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#a2794b"></path><path d="M309.973 150.095 257.529 92.65h-42.974v-3.816l-16.681 1.053V48.546a9.8 9.8 0 0 0-.217-2.367c-.764-3.533-3.41-6.378-7.128-7.702l-7.755-3.403-14.394-6.316-1.537-.674h-1.678c-4.963 0-9 4.037-9 9V89.89H156l-16.556-1.056v3.816H91.47l-52.444 57.445 112.147 113.623a106.4 106.4 0 0 1-4.896 15.838c-3.945 9.906-8.35 16.59-9.444 18.222-2.731 4.073-5.18 7.725-9.444 11.611-1.615 1.472-2.709 2.265-7.222 6.111a489 489 0 0 0-6.958 6.042c2.301.259 5.709.636 9.847 1.069 7.434.779 11.151 1.169 11.833 1.167 10.798-.029 19.149-5.605 21.897-7.49 3.557-2.439 6.134-5.002 8.547-7.732 8.957-10.133 15.403-22.272 19.657-31.834z"></path><path d="M206.333 97.583c-5.297.329-10.799.569-16.454.724v-10.64h-.004V48.381a1.8 1.8 0 0 0-.036-.51c-.283-1.309-1.966-1.854-2.2-1.926l-22.472-9.861a1 1 0 0 0-1 1v61.231a476 476 0 0 1-16.75-.732v8.25c4.68.266 9.491.475 14.424.618v4.799l2.326 3.041v26.322a362 362 0 0 0-36.25-26.072l61.963 56.458v-56.715l1.961-3.076v-4.754c4.957-.143 9.79-.353 14.493-.621zm-41.666 111.875 23.125 22.25a159.6 159.6 0 0 1-6.292 30c-2.72 8.705-5.637 17.821-12.292 28.25-5.623 8.812-14.528 22.766-29.479 25.312-2.934.5-5.438.447-7.146.312a95 95 0 0 0 7.632-8.741c11.235-14.589 15.274-28.721 18.43-40.182 5.049-18.336 5.565-33.542 5.938-44.55.177-5.214.148-9.573.084-12.651" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-kaid'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
